$(document).ready(function(){
  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
    }
  });
})
$(document).on('click', '.toggle-favorite', function(e) {
  e.stopPropagation();
  var favoritable_id = $(this).data('id');
  var user = $(this).data('user');
  var url = $(this).data('url');
  var _this = $(this);
  if (user == '') {
    var modal_open = function() {
      $('#modal_login').modal();
    };
    modal_open();
  } else {
    $.ajax({
      url: url,
      type: 'post',
      dataType: 'json',
      data: {
        favoritable_id: favoritable_id,
        user_id: user
      },
      success: function(result) {
        // cssで前方一致でレイアウト指定してしまっているのでattrで書き換える
        if (result == 'ok') {
          _this.attr('class', 'fa fa-heart toggle-favorite');
        } else {
          _this.attr('class', 'fa fa-heart-o toggle-favorite');
        }
      }
    })
  }
})
